import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule } from '../button/button.module';

import { ImpersonationBarComponent } from './impersonation-bar.component';

@NgModule({
  declarations: [ImpersonationBarComponent],
  imports: [CommonModule, ButtonModule],
  exports: [ImpersonationBarComponent],
})
export class ImpersonationBarModule {}
